"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.search_user = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const search_user = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'search-user-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25C12.8995 15.25 15.25 12.8995 15.25 10C15.25 7.10051 12.8995 4.75 10 4.75ZM3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 11.5938 16.1976 13.0585 15.2739 14.2133L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L14.2133 15.2739C13.0585 16.1976 11.5938 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { d: 'M7 11.5C7 10.6716 7.67157 10 8.5 10H11.5C12.3284 10 13 10.6716 13 11.5V12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12V11.5Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { d: 'M8.5 8.5C8.5 7.67157 9.17157 7 10 7C10.8284 7 11.5 7.67157 11.5 8.5C11.5 9.32843 10.8284 10 10 10C9.17157 10 8.5 9.32843 8.5 8.5Z', fill: '#4B5563' })));
};
exports.search_user = search_user;
